import React, { useState } from 'react'
import { EnvelopeIcon } from '@heroicons/react/24/outline'
import AuthLayout, { AuthLink, ErrorBox, Field, SubmitButton, inputClass } from '../components/auth/AuthLayout'
import { requestPasswordReset, errorText } from '../api/auth'
import useDocumentTitle from '../hooks/useDocumentTitle'

const PasswordResetRequest = () => {
  useDocumentTitle('Reset hasła')

  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [sent, setSent] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    const res = await requestPasswordReset(email.trim())
    setBusy(false)

    // Błąd pokazujemy WYŁĄCZNIE przy awarii sieci albo limicie prób.
    // „Nie ma takiego konta" celowo NIE jest komunikowane — inaczej formularz
    // resetu staje się narzędziem do sprawdzania, kto ma u nas konto.
    if (res.networkError) {
      setError(errorText(res))
      return
    }
    if (res.errors && res.errors.some((x) => /too many/i.test(x.message || ''))) {
      setError('Zbyt wiele prób. Odczekaj chwilę i spróbuj ponownie.')
      return
    }
    setSent(true)
  }

  if (sent) {
    return (
      <AuthLayout
        title="Sprawdź skrzynkę"
        subtitle={`Jeśli konto z adresem ${email} istnieje, wysłaliśmy na nie link do ustawienia nowego hasła.`}
        footer={<AuthLink to="/logowanie">Wróć do logowania</AuthLink>}
      >
        <div className="flex justify-center py-4">
          <EnvelopeIcon className="w-14 h-14 text-blue-500" />
        </div>
        <p className="text-sm text-gray-500 leading-6">
          Wiadomość nie dotarła? Sprawdź folder <strong>spam</strong> i upewnij się, że podałeś
          adres użyty przy rejestracji.
        </p>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      title="Nie pamiętam hasła"
      subtitle="Podaj adres e-mail użyty przy rejestracji. Wyślemy link do ustawienia nowego hasła."
      footer={<AuthLink to="/logowanie">Wróć do logowania</AuthLink>}
    >
      <form onSubmit={submit} noValidate>
        <ErrorBox>{error}</ErrorBox>
        <Field label="Adres e-mail">
          <input type="email" required autoComplete="email" className={inputClass}
                 value={email} onChange={(e) => setEmail(e.target.value)} disabled={busy} />
        </Field>
        <SubmitButton busy={busy}>Wyślij link</SubmitButton>
      </form>
    </AuthLayout>
  )
}

export default PasswordResetRequest
